import { Injectable } from '@angular/core';

import { DateTime } from 'luxon';

import { ICalendarDates } from './calendar.interface';

@Injectable()
export class CalendarEventService {
    constructor() {}

    updateDates(direction: string, start: string): ICalendarDates {
        const startDate = DateTime.fromISO(start);
        const days = 7;

        if (direction === 'next') {
            return this.createDatesObject(this.plusDays(startDate, days), this.plusDays(startDate, days + (days - 1)));
        }

        if (direction === 'prev') {
            return this.createDatesObject(this.minusDays(startDate, days), this.minusDays(startDate, 1));
        }

        if (direction === 'fromDatepicker') {
            return this.createDatesObject(startDate.toFormat('yyyy-LL-dd'), this.plusDays(startDate, days));
        }
    }

    plusDays(startDate, days): string {
        return startDate.plus({ days }).toFormat('yyyy-LL-dd');
    }

    minusDays(startDate, days): string {
        return startDate.minus({ days }).toFormat('yyyy-LL-dd');
    }

    createDatesObject(start, end): ICalendarDates {
        return {
            startDate: start,
            endDate: end
        };
    }
}
